import { onDomReady } from '../../components/dynamic/observer';
import CallTouchRequester from '../../components/jivo/calltouchRequester';

onDomReady(() => new CallTouchRequester());